// src/components/common/Popover/Popover.jsx
import React from 'react';
import styles from './Popover.module.css';

/**
 * Hover/keyboard-focus popover with rich content (InfoIcon equivalent for JSX content).
 *
 * @param {Object} props
 * @param {React.ReactNode} props.trigger - Element that opens the popover
 * @param {React.ReactNode} props.children - Popover content
 * @param {'top'|'bottom'} [props.placement] - Panel placement (default 'bottom')
 * @param {'center'|'start'|'end'} [props.align] - Horizontal alignment (default 'center')
 * @param {string} [props.className] - Additional CSS class
 */
const Popover = ({ trigger, children, placement = 'bottom', align = 'center', className = '' }) => {
  if (!children) return trigger;

  return (
    <span
      className={`${styles.popoverWrapper} ${className}`}
      data-placement={placement}
      data-align={align}
      tabIndex={0}
    >
      {trigger}
      <span className={styles.popoverPanel} role="tooltip">{children}</span>
    </span>
  );
};

export default Popover;
